import { Injectable, ElementRef, Output, EventEmitter } from "@angular/core";
//import { Http, Headers } from "@angular/http";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { saveAs as importedSaveAs } from "file-saver";
import { of, pipe, Observable } from "rxjs";
import { concatMap, timeout, catchError, delay, map } from "rxjs/operators";
import { DatePipe } from "@angular/common";

import { ConnectionService } from "ng-connection-service";
import { environment } from "../../environments/environment";
import { DriverProvider } from 'protractor/built/driverProviders';
import { Signup } from '../components/signup/model/signup.model';
import { SortingCurrentStatus, SortingModel } from '../components/app-modules/dashboard/components/dashboard-mngnt/sortingModel';
import { User } from '../components/app-modules/dashboard/models/user.model';
@Injectable({
  providedIn: "root"
})
export class ServiceService {
  
  title = "internet-connection-check";
  status = "ONLINE"; //initializing as online by default
  isConnected = true;

  servers = new Map();
  
  

  @Output() syncEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() loadData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public http: HttpClient,
    private connectionService: ConnectionService,
    private datePipe: DatePipe
  ) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
      } else {
        this.status = "OFFLINE";
      }
      //alert(this.status);
    });

      this.servers.set("172.31.69.99", "[PRODUCTION CENTRAL HUB]");
      this.servers.set("172.31.80.42", "[QWDS MINI HUB]");
      this.servers.set("172.31.85.128", "[ISTC MINI HUB]");
      this.servers.set("172.31.30.201", "[HUB_4]");
      this.servers.set("172.31.13.117", "[HUB_5]");
      this.servers.set("172.31.60.101", "[DEMO]");
      this.servers.set("83.136.182.91", "[localhost]");
    
  }

  public getJSON(filename: String): Observable<any> {
    return this.http.get("./assets/" + filename);
  }

  // sendOTP(url: string, time: number) {
  //   var body: Object;
  //   if (this.status === "OFFLINE") {
  //     return of(`OFFLINE`);
  //   } else {
  //     return this.http.post(url, body).pipe(
  //       timeout(time),
  //       catchError(error => of(`Timeout`))
  //     );
  //   }
  // }

  getDataDirect(url: string, time: number) {
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {
      //const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
      //this.reqHeaderLogin = new Headers({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
      return this.http.get(url).pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
    }
  }

  public findLookup(lookupName: string, url: string, time: number): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'lookup-name': lookupName
    });

    return this.http.get(environment.apiURL + url, {headers: headers}).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  public savePrice(product: any, url: string, time: number, itemName?, colorName?, sizeName?): Observable<any> {
    let headers = new Headers({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'item-name': itemName
    });


    return this.http.get(environment.apiURL + url).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  public delete(itemId, itemType, url: string, time: number): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'item-id': itemId+"",
      'parent-lookup-name': itemType
    });

    return this.http.get(environment.apiURL + url, {headers: headers}).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  public validatePrice(url: string, time: number, itemName?, colorName?, sizeName?): Observable<any> {
    let headers = new Headers({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'item-name': itemName,
      'size-name': sizeName,
      'color-name': colorName
    });

    return this.http.get(environment.apiURL + url).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  onSubmit(name: string, myFile: any, avatar: ElementRef, uploadForm: any, url: string, time: number): Observable<any> {

    const formData = new FormData();
    // formData.append('file', uploadForm.get('profile').value);

    formData.append('uploadedFile', uploadForm.get('profile').value);
    formData.append('description', "My Desc");
    formData.append('companyName', "ABC")
    formData.append('numberOfRecords', "2")


    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      // 'folder': environment.imagePath + '/images/logo/',
      // 'Content-Type': "multipart/form-data; boundary='zabrafan'",
    });

    var options = { content: formData };
    let fileName = myFile[0].name.split('.').slice(0, -1).join('.')

    return this.http.get(environment.apiURL + url + + "?file-name=" + fileName +
      "&names=" + fileName + "&file-names=yatch&billoflading-id=78&detail-id=1&types=signature&file-name=apple").pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
  }

  public validateLookup(lookup: string, parentLookup: string, url: string, time: number): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'lookup-name': lookup,
      'parent-lookup-name': parentLookup
    });

    return this.http.post(environment.apiURL + url, null, {headers: headers}).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  public saveLookup(lookups: any, parentLookup: string, url: string, time: number): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
      'lookup-name': parentLookup
    });


    return this.http.post(environment.apiURL + url, lookups, {headers: headers}).pipe(
      timeout(time),
      catchError(error => of(`Timeout`))
    );
  }

  getData(url: string, time: number) {
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {
      const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
      // this.reqHeaderLogin = new Headers({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
      return this.http.get(environment.apiURL + url).pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
    }
  }

  getUsers(url: string, time: number) {
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {

      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
        'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod"
      });


      return this.http.get(environment.apiURL + url, { headers: headers }).pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
    }
  }

  // postData(body: object, url: string) {
  //   //post data to create a new entry in the database
  //   return this.http.post(environment.apiURL + url, body);
  // }
  //postDataJson(body: string, url: string, time: number) {
  postData(body: object, url: string, time: number) {
    //post data to create a new entry in the database
    //let headers = new HttpHeaders();
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {
      //const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
      //this.reqHeaderLogin = new Headers({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
      return this.http.post(environment.apiURL + url, body).pipe(
        timeout(time),
        catchError(error => of())
      );
    }
    //return this.http.post(environment.apiURL + url, body);
  }

  putData(body: object, url: string, time: number) {
    //post data to create a new entry in the database
    //let headers = new HttpHeaders();
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {
      //const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
      //this.reqHeaderLogin = new Headers({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
      return this.http.put(environment.apiURL + url, body).pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
    }
    //return this.http.post(environment.apiURL + url, body);
  }

  deleteData(url: string, time: number) {
    //post data to create a new entry in the database
    //let headers = new HttpHeaders();
    if (this.status === "OFFLINE") {
      return of(`OFFLINE`);
    } else {
      //const headers = new HttpHeaders({'Content-Type':'application/json; charset=utf-8'});
      //this.reqHeaderLogin = new Headers({ "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" });
      return this.http.delete(environment.apiURL + url).pipe(
        timeout(time),
        catchError(error => of(`Timeout`))
      );
    }
    //return this.http.post(environment.apiURL + url, body);
  }



  public postSocialUserData(body: object, url: string, time: number): Observable<any> {
    return this.http.post(environment.apiURL + url, body, { observe: 'response' });
  }


  /**************************CE CONNECT START***********************/

  /**
   * Find tenant details by emial..
   *
   * @param url
   * @param email
   */
  public findTenant(url: string, email?: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'user-name': email,
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });
  }

  public firstLogin(body: object, url: string, scac?: string, time?: number): Observable<any> {
    let headers = {};
      headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'Authorization': 'Basic bXktdHJ1c3RlZC1jbGllbnQ6c2VjcmV0',
        'scac': scac,
        'request-source': 'WEB',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      });

    return this.http.post(environment.apiURL + url, body, {
      headers: headers
    });
  }

  public getUserList(url: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod"
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });

  }

  public getRouteForBol(bolId, bolTenantId): Observable<any>{
    let headers = {};
    let url = "get-routeid-for-bol";
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'bol-id': bolId+"",
      'bol-tenant-id': bolTenantId+""
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });
  }

  public getImagesForBol(bolId, bolTenantId): Observable<any>{
    let headers = {};
    let url = "get-bol-image-urls";
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'bol-id': bolId+"",
      'bol-tenant-id': bolTenantId+""
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });
  }

  hideCompletedLoads = false;
  filterDivision = null;
  shiftSorting = null;

  public getBillOfladdings(url: string, fromDate: string, toDate: string,
    filterQuery?: any,  orderNoFIlter?: any,
    carrierFilter?: any,
    terminalFilter?: any,
    supplierFilter?: any,
    dealerFilter?: any,
    bolStatusFilter?: any,
    notesFilter?: any,
    csvExport?: any,
    clearCache?: any,
    sortingCurrentStatus?: SortingModel[],
    tacFilter?: any,
    invoiceFilter?: any,
    loadingBolFilter?: any,
    billtypeFilter?: any,
    size?: number,
    ): Observable<any> {

    let headers = new HttpHeaders().set('Content-Type','application/json');
    headers = headers.set('Authorization','Bearer ' + localStorage.getItem("access_token"));
    headers = headers.set('scac',JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod");
    headers = headers.set('from-date',fromDate);
    headers = headers.set('to-date', toDate);

    if (csvExport) {
      headers = headers.set('Accept', 'Blob');
    } else {
      headers = headers.set('Accept', 'application/json');
    }

    if (null != carrierFilter && carrierFilter !== '') {
      headers = headers.set('carrier-filter', carrierFilter+"");
    }

    if (null != supplierFilter && supplierFilter !== '') {
      headers = headers.set('supplier-filter', supplierFilter+"");
    }

    if (null != terminalFilter && terminalFilter !== '') {
      headers = headers.set('terminal-filter', terminalFilter+"");
    }

    if (null != dealerFilter &&  dealerFilter !== '') {
      headers = headers.set('dealer-filter', dealerFilter+"");
    }

    if (null != orderNoFIlter && orderNoFIlter !== '') {
      headers = headers.set('order-no', orderNoFIlter+"");
    }
    if (null != filterQuery && filterQuery !== '') {
      headers = headers.set('text-filter', filterQuery+"");
    }
    if (null != loadingBolFilter && loadingBolFilter !== '') {
      headers = headers.set('loading-bol-filter', loadingBolFilter+"");
    }
    if (null != bolStatusFilter && bolStatusFilter !== '') {
      headers = headers.set('bol-status-filter', bolStatusFilter+"");
    }


    if(null != tacFilter && tacFilter != '' && tacFilter){
      headers = headers.set('tac-filter', tacFilter+"");
    }

    if(null != invoiceFilter && invoiceFilter != '' && invoiceFilter){
      headers = headers.set('invoice-filter', invoiceFilter+"");
    }

    if(null != billtypeFilter && billtypeFilter != '' && billtypeFilter){
      headers = headers.set('billtype-filter', billtypeFilter+"");
    }
    if(null != this.hideCompletedLoads){
      headers = headers.set("hide-completed-loads", this.hideCompletedLoads+"");
    }
    if(null != this.filterDivision && "" != this.filterDivision && this.filterDivision){
      headers = headers.set("division-filter", this.filterDivision+"");
    }

    if (notesFilter == "") {
      notesFilter = null;
    }
    if (null != notesFilter) {
      headers = headers.set('notes-filter', notesFilter);
    }

    if (null != clearCache && clearCache !== '') {
      headers = headers.set("clear-cache", clearCache);
    }

    if(csvExport) {
      const a: string = environment.apiURL + 'export-csv?size=' + (size ? size : 10) + '&page=' + 1 + '&sort-by=scheduleDate,billOfLadingId&order-by=desc,asc';

    return this.http.get(a, { headers: headers, responseType: "arraybuffer"});
    } else {
      
      if(sortingCurrentStatus && sortingCurrentStatus[0]?.fieldName == "shift"){
        headers = headers.set("sort-by", "shift");
        headers = headers.set("order-by", this.shiftSorting == "asc"?"asc": "desc");
      }
      return this.http.post(environment.apiURL + url, sortingCurrentStatus, {
        headers: headers
      });

      // return this.http.post(environment.apiURL + url, sortingCurrentStatus, {
      //     headers: headers
      //   });

      SortingCurrentStatus
    }


  }

  /**
   * Download file
   * @param fileName
   * @param currentFileType
   * @param scac
   */
  downloadFiles(fileName, currentFileType, scac): Observable<any> {
    let headers = new HttpHeaders({
      'Accept': 'Blob',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'file-name': fileName + '.' + currentFileType,
      'request-source': 'WEB',
      'tenant-scac': scac,
    });

    const a: string = environment.apiURL + 'download';
    return this.http.get(a, { headers: headers, responseType: "arraybuffer" });
  }

  /**
   * Download invoice / will remove  this after testing
   * @param fileName
   * @param currentFileType
   * @param scac
   */
  downloadInvoice(fileName, currentFileType, scac): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Accept': 'Blob',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'file-name': fileName + '.' + currentFileType,
      'request-source': 'WEB',
      'tenant-scac': scac,
    });

    const a: string = environment.apiURL +'download-invoice';
    return this.http.get(a, { headers: headers, responseType: "arraybuffer" });
  }

  listFilesFromS3InvoiceFolder(fileNames, bolFileNames, scac, extension): Observable<any> {
    fileNames = fileNames.map(fileName => fileName+extension);
    bolFileNames = bolFileNames.map(fileName => fileName+extension);
    // convert arrays to comma-separated strings because server expects "a,b,c" strings
    const body = {
      'file-names': fileNames.join(','),        // e.g. "4761309::59.pdf,4761311::59.pdf"
      'bol-file-names': bolFileNames.join(',')
    };

    // Build headers. Let HttpClient set content-type automatically (recommended)
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
      'scac': JSON.parse(localStorage.getItem('user-tenant') || 'null') ? JSON.parse(localStorage.getItem('user-tenant')).scac : 'prod',
      'tenant-scac': scac
    });

    const url = environment.apiURL + 'list-files-from-S3-invoice-folder';
    return this.http.post(url, body, { headers }); // Content-Type will be application/json
  }

  listFilesUrlFromS3(bolIds, folder, scac): Observable<any> {
    
    let headers = {};
    headers = new HttpHeaders({
      // 'Accept': 'application/pdf',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'bol-ids': bolIds,
      'directory': folder,
      // 'request-source': 'WEB',
      'tenant-scac': scac,
    });
    

    const a: string = environment.apiURL +'get-thumbnails-with-validation';
    return this.http.get(a, { headers: headers });
  }

  getUserDataAccessSpecs(): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL + 'get-user-data-access?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getLoggedInUserDetails(): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod"
    });

    const a: string = environment.apiURL + 'get-driver-details-secured';
    return this.http.get(a, { headers: headers });
  }

  getLoggedInUserDetailsForFtp(scac): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("ftp_access_token"),
      'scac':  scac
    });

    const a: string = environment.apiURL + 'gps/get-driver-details';
    return this.http.get(a, { headers: headers });
  }


  public setLoadData(data: any): void {
    this.loadData.emit(data);
  }


  public syncEventApi(): void {
    this.syncEvent.emit(true);
  }



  public getHeapStatus(fromDate: string, toDate: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'from-date': fromDate + ' 00:00:00',
      'to-date' : toDate + ' 00:00:00'
    });

    const a: string = environment.apiURL + 'process/get-status-list-separate?page=0&size=10&sort-by=tStamp&order-by=desc';
    return this.http.get(a, { headers: headers });
  }


  public getTenant(): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token")
    });

    const a: string = environment.apiURL + 'public/get-tenant-activities?page=0&size=100';
    return this.http.get(a, { headers: headers });
  }

  public getDriversByTenant(tenantId?: any): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'tenant-id' : tenantId
    });

    const a: string = environment.apiURL + 'get-drivers-for-tenant?page=0&size=1000';
    return this.http.get(a, { headers: headers });
  }

  public getLoadsByDriverAndTenantAndDate(tenantId: any, driverId: any, fromDate: string, toDate: string, distanceDifference: number): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'tenant-id' : tenantId,
      'driver-id' : driverId,
      'from-date': fromDate + ' 00:00:00',
      'to-date' : toDate + ' 00:00:00',
      'distance-difference': distanceDifference+''
    });

    const a: string = environment.apiURL + 'find-routes-for-driver?page=0&size=2000000';
    return this.http.get(a, { headers: headers });
  }

  getTerminals(): Observable<any> {
    let headers = new HttpHeaders();
      headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
      headers = headers.set('Accept', 'application/json');
      headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem("access_token"));
      headers = headers.set('scac', localStorage.getItem("user_scac"));
      headers = headers.set('request-source', 'WEB');


    const a: string = environment.apiURL +
      'get-all-dasboard-terminals?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getSuppliers(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-all-dasboard-suppliers?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getBilltypes(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-all-dasboard-billtypes?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getDealers(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-all-dasboard-dealers?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }


  public getTenantActivities(url: string, fromDate: string, toDate: string,
    filterQuery?: any,  orderNoFIlter?: any,
    carrierFilter?: any,
    terminalFilter?: any,
    supplierFilter?: any,
    dealerFilter?: any,
    bolStatusFilter?: any,
    notesFilter?: any,
    csvExport?: any,
    clearCache?: any,
    ): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type','application/json');
    headers = headers.set('Authorization','Bearer ' + localStorage.getItem("access_token"));
    headers = headers.set('scac',JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod");
    headers = headers.set('from-date',fromDate);
    headers = headers.set('to-date', toDate);

    if (csvExport) {
      headers = headers.set('Accept', 'Blob');
    } else {
      headers = headers.set('Accept', 'application/json');
    }

    if (null != carrierFilter && carrierFilter !== '') {
      headers = headers.set('carrier-filter', carrierFilter);
    }

    if (null != supplierFilter && supplierFilter !== '') {
      headers = headers.set('supplier-filter', supplierFilter);
    }

    if (null != terminalFilter && terminalFilter !== '') {
      headers = headers.set('terminal-filter', terminalFilter);
    }

    if (null != dealerFilter &&  dealerFilter !== '') {
      headers = headers.set('dealer-filter', dealerFilter);
    }

    if (null != orderNoFIlter && orderNoFIlter !== '') {
      headers = headers.set('order-no', orderNoFIlter);
    }
    if (null != filterQuery && filterQuery !== '') {
      headers = headers.set('text-filter', filterQuery);
    }

    if (null != bolStatusFilter && bolStatusFilter !== '') {
      headers = headers.set('bol-status-filter', bolStatusFilter);
    }

    if (notesFilter == "") {
      notesFilter = null;
    }
    if (null != notesFilter) {
      headers = headers.set('notes-filter', notesFilter);
    }

    if (null != clearCache && clearCache !== '') {
      headers = headers.set("clear-cache", clearCache);
    }

    if(csvExport) {
      const a: string = environment.apiURL;

    return this.http.get(a, { headers: headers, responseType: "arraybuffer"});
    } else {
      return this.http.get(environment.apiURL + url, {
        headers: headers
      });
    }
  }

  getUserWhoOwnsItDetails(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-user-who-owns-it?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getTenants(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-tenants-billtype-mapping?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getAssociatedTenants(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-associated-tenants';
    return this.http.get(a, { headers: headers });
  }

  getAssociatedBilltypes(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-associated-billtypes';
    return this.http.get(a, { headers: headers });
  }

  getTblDivisions(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-tbl-divisions';
    return this.http.get(a, { headers: headers });
  }

  getDealersForTenant(tenantId): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'tenant-id': tenantId,
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-related-dealers-for-tenant?page=0&size=10000';
    return this.http.get(a, { headers: headers });
  }

  getDealersForBilltypes(tenantId, billingCode): Observable<any> {
    
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'tenant-id': tenantId,
      'billing-code': billingCode+"",
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-related-dealersncards-for-billtype?page=0&size=10000';
    return this.http.get(a, { headers: headers });
  }

  getProductsForTenant(tenantId): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'tenant-id': tenantId,
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-products-for-tenant';
    return this.http.get(a, { headers: headers });
  }


  getUsersForFtp(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': localStorage.getItem("user_scac"),
      'request-source': 'WEB',
    });

    const a: string = environment.apiURL +
      'get-all-dasboard-users?size=100&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.get(a, { headers: headers });
  }

  getFTPRelatedBillofladings(size: number, page: number, formattedFromDate, formattedToDate,
    carrierFilter, supplierFilter, terminalFilter, bolStatusFilter, clearCache, notesFilter, orderNoFIlter, csvExport, dealerFilter,
    filterQuery, sortingCurrentStatus?: SortingModel[], billtypeFilter?): Observable<any> {

    let headers = new HttpHeaders().set('Content-Type','application/json');
    headers = headers.set('Accept', 'application/json');
    headers = headers.set("Authorization", 'Bearer ' + localStorage.getItem("access_token"));
    headers = headers.set("scac", JSON.parse(localStorage.getItem("user-tenant")).scac);
    headers = headers.set('request-source', 'WEB');
    headers = headers.set('from-date', formattedFromDate);
    headers = headers.set('to-date', formattedToDate);
    if (csvExport) {
      headers = headers.set('Accept', 'Blob');
    } else {
      headers = headers.set('Accept', 'application/json');
    }

    if (null != carrierFilter) {
      headers = headers.set('carrier-filter', carrierFilter);
    }

    if (null != supplierFilter) {
      headers = headers.set('supplier-filter', supplierFilter);
    }

    if (null != terminalFilter) {
      headers = headers.set('terminal-filter', terminalFilter);
    }

    if (null != dealerFilter) {
      headers = headers.set('dealer-filter', dealerFilter);
    }

    if (null != orderNoFIlter) {
      headers = headers.set('order-no', orderNoFIlter);
    }

    if (null != filterQuery) {
      headers = headers.set('text-filter', filterQuery);
    }

    if (null != bolStatusFilter) {
      headers = headers.set('bol-status-filter', bolStatusFilter+"");
    }
    if (null != billtypeFilter) {
      headers = headers.set('billtype-filter', billtypeFilter+"");
    }

    if (notesFilter == "") {
      notesFilter = null;
    }
    if (null != notesFilter) {
      headers = headers.set('notes-filter', notesFilter);
    }

    if (null != clearCache) {
      headers = headers.set("clear-cache", clearCache+"");
    }

    console.log(headers);

    if (csvExport) {
      const a: string = environment.apiURL +
        'export-ftp-csv?size=' + size + '&page=' + page + '&sort-by=scheduleDate,billOfLadingId&order-by=desc,asc';

      return this.http.get(a, { headers: headers, responseType: "arraybuffer"});
    } else {
      if(page == -1){
        page = 0;
      }

      const a: string = environment.apiURL +
        'get-ftp-bol-details/v2?size=' + size + '&page=' + page + '&sort-by=scheduleDate,billOfLadingId&order-by=desc,asc';
      return this.http.post(a, sortingCurrentStatus, { headers: headers });
    }
  }


  public findDealerAndStationDetails(locationID): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'get-inventory-details?location-id=' + locationID;
    return this.http.get(a, { headers: headers });
  }

  public findDeliverySlots(tenantId): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'tenant-id': tenantId,
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'get-related-delivery-slots';
    return this.http.get(a, { headers: headers });
  }

  public findSelectedDealer(locationId, tenantId): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'tenant-id': tenantId,
      'location-id':locationId+"",
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'get-single-dealer-for-tenant';
    return this.http.get(a, { headers: headers });
  }

  public takeOrder(orderModels, tenantId): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'tenant-id': tenantId,
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'take-order';
    return this.http.post(a, orderModels, { headers: headers });
  }


  public findInventoryHistory(counter, tenant, fromDate, toDate, treatTanksSeparately): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'counter': ""+counter,
      'tenant': ""+tenant,
      'from-date': fromDate,
      'to-date': toDate,
      'treat-tanks-separately': treatTanksSeparately+""
    });

    const a: string = environment.apiURL + 'get-inventory-history';
    return this.http.get(a, { headers: headers });
  }

  public findInventoryDeliveries(counter, tenant, fromDate, toDate): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'counter': ""+counter,
      'tenant': ""+tenant,
      'from-date': fromDate,
      'to-date': toDate
    });

    const a: string = environment.apiURL + 'get-inventory-deliveries';
    return this.http.get(a, { headers: headers });
  }

  public saveReadingRecords(postRecords: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",

    });
    const a: string =  environment.apiURL +
      '/save-inventory-readings';

    return this.http.post(a, postRecords, { headers: headers});
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || {error: ""};
      const err =  JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);

    if (errMsg.indexOf('500 - OK {"message":null}') > -1) {
      window.location.reload();
    }

    if (errMsg.indexOf('500 - OK {}') > -1) {
    }
    if (errMsg.indexOf('IllegalArgumentException') > -1) {
      window.location.reload();
    }
    return Observable.throw(errMsg);
  }



/**     Request Access  */

public saveRequestAccessDetails(url: string, dataObj: Signup) : Observable<any> {
  let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + url;
    return this.http.post(a, dataObj, { headers: headers });
}


/** Fleet status */

private transformDate(): string {
  return this.datePipe.transform(Date.now(), 'yyyy-MM-dd 00:00:00');
}

public getGpsTerminals(): Observable<any> {
  let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + "/gps/find-all-terminals";
    return this.http.get(a, { headers: headers });
}

public getGpsDealers(): Observable<any> {
  let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + "/gps/find-all-dealers?date=" + this.transformDate();
    return this.http.get(a, { headers: headers });
}

public getGpsDriverLocations(): Observable<any> {
  let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + "/gps/find-gps-mappings?date=" + this.transformDate();
    return this.http.get(a, { headers: headers });
}

  /**
   * Saving user details
   *
   */
  public saveUserDetails(user: User, previousPassword: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'previous-password': previousPassword,
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'save-user' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.post(a, user, { headers: headers });
  }

    public saveUserDetailsSingle(user: User, previousPassword: string): Observable<any> {
    let headers = {};
    
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'previous-password': previousPassword ? previousPassword : '',
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'save-user-single' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.post(a, user, { headers: headers });
  }


   /**
   * Deleting user details
   *
   */
  public deleteUserDetails(userId: string): Observable<any> {
    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'user-id': userId,
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'delete-user' + '?size=200&page=0&sort-by=billOfLadingId&order-by=asc';
    return this.http.delete(a, { headers: headers });
  }

  public fetchUserAccess(user: any): Observable<any> {

    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'user-name': user.email,
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'find-user-modules';
    return this.http.get(a, { headers: headers });
  }

  public fetchUserModulesAccess(user: any): Observable<any> {

    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'user-name': user.email,
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'find-user-modules-access';
    return this.http.get(a, { headers: headers });
  }

  public fetchAllModules(): Observable<any> {

    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'get-user-modules';
    return this.http.get(a, { headers: headers });
  }

  public fetchCurrentUserModules(): Observable<any> {

    let headers = {};
    headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac' : JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    const a: string = environment.apiURL + 'find-current-user-modules';
    return this.http.get(a, { headers: headers });
  }

  checkFtpStatus(): any {

    let headerValues = new HttpHeaders();

    headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("ftp_access_token"));
      headerValues = headerValues.set('scac', localStorage.getItem("ftp_user_scac"));
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');

    return this.http.get(environment.apiURL + 'check-ftp-status', {headers: headerValues});
  }

  resendAllFtpFiles(fromDate: string, toDate: string): any {
    let headerValues = new HttpHeaders();

      headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("ftp_access_token"));
      headerValues = headerValues.set('scac', localStorage.getItem("ftp_user_scac"));
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');
      headerValues = headerValues.set('from-date', fromDate);
      headerValues = headerValues.set('to-date', toDate);
      headerValues = headerValues.set('tenant', JSON.parse(localStorage.getItem("ftp_user")).user.tenant.tenantId);

    return this.http.post(environment.apiURL + 'resend-all-ftp-files', {} , {headers: headerValues});
  }

  checkAvailability(fromDate: string, toDate: string, selectedUser) {
    let headerValues = new HttpHeaders();

      headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("ftp_access_token"));
      headerValues = headerValues.set('scac', selectedUser?.tenant?.scac);
      headerValues = headerValues.set('tenant-scac', selectedUser?.tenant?.scac);
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');
      headerValues = headerValues.set('from-date', fromDate);
      headerValues = headerValues.set('to-date', toDate);

    return this.http.get(environment.apiURL + 'check-file-availability', {headers: headerValues});
  }

  resendSingleFtpFile(bolId){
    let headerValues = new HttpHeaders();

      headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("ftp_access_token"));
      headerValues = headerValues.set('scac', localStorage.getItem("ftp_user_scac"));
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');
      headerValues = headerValues.set('bolid', bolId);
      headerValues = headerValues.set('tenant', JSON.parse(localStorage.getItem("ftp_user")).user.tenant.tenantId);

    return this.http.post(environment.apiURL + 'resend-single-ftp-file', {} , {headers: headerValues});
  }

  resendSingleBolFile(bolId, selectedUser){
    
    let headerValues = new HttpHeaders();

    headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("ftp_access_token"));
    headerValues = headerValues.set('scac', selectedUser?.tenant?.scac);
    headerValues = headerValues.set('request-source', 'WEB');
    headerValues = headerValues.set('Content-Type', 'application/json');
    headerValues = headerValues.set('bolid', bolId+"");
    headerValues = headerValues.set('tenant', selectedUser?.tenant?.tenantId);

    return this.http.post(environment.apiURL + 'resend-single-ftp-file', {} , {headers: headerValues});
  }

  fetchDeviceStats(searchCriteria?){
    let headerValues = new HttpHeaders();

      headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("access_token"));
      headerValues = headerValues.set('scac', JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod");
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');

    return this.http.get(environment.apiURL + 'get-device-stats-modified', {headers: headerValues});
  }

  saveDevice(device){
    let headerValues = new HttpHeaders();
    headerValues = headerValues.set('Content-Type', 'application/json');
    return this.http.post(environment.apiURL + 'public/save-device-details', device, {headers: headerValues});
  }

  
  saveDeviceForTenant(device){
    let headerValues = new HttpHeaders();
    headerValues = headerValues.set('Content-Type', 'application/json');
    headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("access_token"));
    headerValues = headerValues.set('scac', JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod");
    headerValues = headerValues.set('request-source', 'WEB');
    
    return this.http.post(environment.apiURL + 'save-device-for-tenant', device, {headers: headerValues});
  }

  public deleteUserModuleMapping(userModuleMapping): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
    });

    return this.http.post(environment.apiURL + 'delete-user-modules', userModuleMapping, {headers: headers}).pipe(
      timeout(3000),
      catchError(error => of(`Timeout`))
    );
  }

  public addUserModuleMapping(userModuleMappings): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'request-source': 'WEB',
      'Content-Type': 'application/json',
    });

    return this.http.post(environment.apiURL + 'add-user-modules', userModuleMappings, {headers: headers}).pipe(
      timeout(3000),
      catchError(error => of(`Timeout`))
    );
  }

  allowOrderFromPortal(){
    let headerValues = new HttpHeaders();

      headerValues = headerValues.set('Authorization', 'Bearer ' + localStorage.getItem("access_token"));
      headerValues = headerValues.set('scac', JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod");
      headerValues = headerValues.set('request-source', 'WEB');
      headerValues = headerValues.set('Content-Type', 'application/json');

    return this.http.get(environment.apiURL + 'allow-order-from-portal', {headers: headerValues});
  }

  public getUserRoleTenantFilter(searchText,page?,size?): Observable<any>{
    let headers = {};
    let url = "get-all-users-role-tenant-search?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'search-text': searchText+""
    });

    return this.http.get(environment.apiURL + url, {
      headers: headers
    });
  }

  public getLoadDetails(loadDetailFilter, page?,size?): Observable<any>{

    let headers = {};
    let url = "get-all-load-details?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'Content-Type': 'application/json',
    });
    const a: string =  environment.apiURL + url;
    return this.http.post(a,loadDetailFilter, {
      headers: headers
    });
  }

  public getStationPhonebook(page = -1, size = 100, sortBy = "locationID", orderBy = "asc"): Observable<any>{

    let headers = {};
    let url = "get-station-phone-book?page="+page+"&size="+size+"&sort-by="+sortBy+"&order-by="+orderBy+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'Content-Type': 'application/json',
    });
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {headers: headers});
  }

  public getInventoryDetails(locationId){
    let headers = {};
    let url = "get-inventory-details?location-id="+locationId;
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
      'Content-Type': 'application/json',
    });
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {headers: headers});
  }

  getIpAddress() {
    return this.http.get('https://api.ipify.org/?format=json');
  }

  public getDriverRouteSheetDetails(drsFilter, page?,size?): Observable<any>{
    
    let headers = {};
    let url = "get-drs?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'from-date': drsFilter?.drsStartDate + " 00:00:00",
      'to-date': drsFilter?.drsEndDate + " 23:59:59",
      'tenant-scac': drsFilter?.scac + "",
    });
    
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {
      headers: headers
    });
  }

  public getBolFromDrsDetails(routeId, scac , page?,size?): Observable<any>{
    let headers = {};
    let url = "get-bol-details-drs?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'route-id': routeId + "",
      'tenant-scac': scac,
    });
    
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {
      headers: headers
    });
  }

  public getTblUsersByLogon(logon, scac): Observable<any>{
    
    let headers = {};
    let url = "get-tbl-users-by-logon";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'logon': logon,
      'tenant-scac': scac,
    });
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {
      headers: headers
    });
  }

  public getBolDetailsFromBol(bolId, scac , page?,size?): Observable<any>{
    let headers = {};
    let url = "get-bol-details-bol?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'bol-id': bolId + "",
      'tenant-scac': scac,
    });
    
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {
      headers: headers
    });
  }

  public getBolDetails(bolFilter,  page?, size?): Observable<any>{
    
    let headers = {};
    let url = "get-bol?page="+page+"&size="+size+"";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'tenant-scac': bolFilter?.scac,
      'bol-id' : bolFilter?.bolId + "",
      'route-id' : bolFilter?.routeId + "",
      'driver-id' : bolFilter?.driverId + "",
      'schedule-date' : bolFilter?.selectedDateText + "",
      'logon' : bolFilter?.logon + "",
      'fname' : bolFilter?.fname + "",
      'lname' : bolFilter?.lname + "",
    });
    const a: string =  environment.apiURL + url;
    return this.http.get(a, {
      headers: headers
    });
  }

  public findCCompleteTenant(scac): Observable<any>{
    let headers = {};
    let url = "find-complete-tenant-with-schema";
    headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac':  JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "demo",
      'Content-Type': 'application/json',
      'tenant-scac': scac,
    });

    
    
    const a: string =  environment.apiURL + url;
    return this.http.post(a, {}, {
      headers: headers
    });
  }

}

